// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { XNGAGE_CUSTOM_WIDGET } from "@rpsc/XDL/constants";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface ErpOrderNumberStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    erpOrderNumber?: TypographyProps;
}

export const erpOrderNumberStyles: ErpOrderNumberStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};

const styles = erpOrderNumberStyles;

const ErpOrderNumber: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order?.erpOrderNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="erpOrderNumber">
                {translate("ERP Order #")}
            </Typography>
            <Typography {...styles.erpOrderNumber} aria-labelledby="erpOrderNumber" data-test-selector="erpOrderNumber">
                {order.erpOrderNumber}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ErpOrderNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: XNGAGE_CUSTOM_WIDGET,
    },
};

export default widgetModule;
